import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FullscreenExitIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M3.85999 13.08V14.72H7.01999C7.71999 14.72 8.23999 15.24 8.23999 15.94V19H9.87999V15.84C9.87999 14.08 8.87999 13.08 7.11999 13.08H3.85999ZM20.14 13.08H16.88C15.12 13.08 14.12 14.08 14.12 15.84V19H15.76V15.94C15.76 15.24 16.28 14.72 16.98 14.72H20.14V13.08ZM3.85999 10.92H7.11999C8.87999 10.92 9.87999 9.92 9.87999 8.16V5H8.23999V8.06C8.23999 8.76 7.71999 9.28 7.01999 9.28H3.85999V10.92ZM20.14 10.92V9.28H16.98C16.28 9.28 15.76 8.76 15.76 8.06V5H14.12V8.16C14.12 9.92 15.12 10.92 16.88 10.92H20.14Z"
      />
    </SvgIcon>
  );
});
